import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-score-detail',
  templateUrl: './score-detail.component.html',
  styleUrls: ['./score-detail.component.css']
})
export class ScoreDetailComponent {

  @Input() candidate: any;
  @Input() type: any;

  constructor(){}

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  //@TOFIX: duplicated
  /**
   * Returns a string list of items for tooltip display.
   * @param contractTypes - An array of items.
   * @returns A string listing the items names.
   */
  getListAsString(list: any[]): string {
    if (Array.isArray(list)) {
      return list.map(key => key ?? '').join(', ');
    } else {
      return '';
    }
  }

  /**
   * Maps an availability code to its corresponding label.
   *
   * @param {string | undefined} availability - The availability code to map.
   *   Possible values:
   *   - '1': 'Immédiate'
   *   - '2': '2 mois'
   *   - '3': '3 mois'
   *   - '4': '4 mois'
   * @returns {string} The corresponding label for the availability code.
   *   Returns an empty string if the code is undefined or unrecognized.
   */
  getAvailabilityLabel(availability: string | undefined): string {
    const availabilityMap: { [key: string]: string } = {
      '1': 'Immédiate',
      '2': '2 mois',
      '3': '3 mois',
      '4': '4 mois',
    };
    return availability ? availabilityMap[availability] || '' : '';
  }

}
